"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DmsLdapAuthenticatorSettings = void 0;
var _react = _interopRequireWildcard(require("react"));
var _DmsForm = require("../DmsForm/DmsForm");
var _reactIntlUniversal = _interopRequireDefault(require("react-intl-universal"));
var _DmsTextField = require("../DmsTextField/DmsTextField");
var _DmsTextFieldIpv = require("../DmsTextField/DmsTextFieldIpv4");
var _DmsTextFieldPort = require("../DmsTextField/DmsTextFieldPort");
var _DmsTokenHook = require("../DmsTokenHook/DmsTokenHook");
var _material = require("@mui/material");
var _useGet = require("../../Hooks/useGet");
var _DmsLoading = require("../DmsLoading/DmsLoading");
var _DmsSwitch = require("../DmsSwitch/DmsSwitch");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const DmsLdapAuthenticatorSettings = () => {
  var _ldapSettingsData$ipv, _ldapSettingsData$por, _ldapSettingsData$bin, _ldapSettingsData$bin2, _ldapSettingsData$sea, _ldapSettingsData$sea2, _ldapSettingsData$use, _ldapSettingsData$use2, _ldapSettingsData$use3, _ldapSettingsData$use4, _ldapSettingsData$gro, _ldapSettingsData$gro2;
  const token = (0, _DmsTokenHook.getToken)();
  const {
    data,
    isLoading
  } = (0, _useGet.useGet)('/ldap_authenticator_settings', null, true);
  const [ldapSettingsData, setLdapSettingsData] = (0, _react.useState)(null);
  (0, _react.useEffect)(() => {
    if (data) {
      setLdapSettingsData(data.data);
    }
  }, [data]);
  const handleChange = (name, value) => {
    setLdapSettingsData(prevData => _objectSpread(_objectSpread({}, prevData), {}, {
      [name]: value
    }));
  };
  if (isLoading || !ldapSettingsData) {
    return /*#__PURE__*/_react.default.createElement(_DmsLoading.DmsLoading, null);
  }
  return /*#__PURE__*/_react.default.createElement(_DmsForm.DmsForm, {
    url: '/ldap_authenticator_settings',
    method: "PUT",
    token: token,
    fieldTypes: {
      enabled: 'bool',
      ipv4: 'string',
      port: 'int',
      use_ssl: 'bool',
      bind_dn: 'string',
      bind_password: 'string',
      search_base_dn: 'string',
      search_filter: 'string',
      user_name_attribute: 'string',
      user_email_attribute: 'string',
      user_member_attribute: 'string',
      user_attribute_group_search: 'string',
      group_search_base_dn: 'string',
      group_search_filter: 'string',
      block_users_without_groups: 'bool'
    }
  }, /*#__PURE__*/_react.default.createElement(_DmsForm.DmsForm.Body, null, /*#__PURE__*/_react.default.createElement(_material.Grid, {
    container: true,
    spacing: 2
  }, /*#__PURE__*/_react.default.createElement(_material.Grid, {
    item: true,
    xs: 12,
    sm: 4,
    md: 4,
    lg: 4
  }, /*#__PURE__*/_react.default.createElement(_DmsTextFieldIpv.DmsTextFieldIpv4, {
    name: "ipv4",
    label: _reactIntlUniversal.default.get("IPV4").d("IPV4"),
    fullWidth: true,
    value: (_ldapSettingsData$ipv = ldapSettingsData.ipv4) !== null && _ldapSettingsData$ipv !== void 0 ? _ldapSettingsData$ipv : "",
    onChange: e => handleChange("ipv4", e.target.value)
  })), /*#__PURE__*/_react.default.createElement(_material.Grid, {
    item: true,
    xs: 12,
    sm: 4,
    md: 4,
    lg: 4
  }, /*#__PURE__*/_react.default.createElement(_DmsTextFieldPort.DmsTextFieldPort, {
    name: "port",
    label: _reactIntlUniversal.default.get("Port").d("Port"),
    fullWidth: true,
    value: (_ldapSettingsData$por = ldapSettingsData.port) !== null && _ldapSettingsData$por !== void 0 ? _ldapSettingsData$por : "",
    onChange: e => handleChange("port", e.target.value)
  })), /*#__PURE__*/_react.default.createElement(_material.Grid, {
    item: true,
    xs: 12,
    sm: 4,
    md: 4,
    lg: 4
  }, /*#__PURE__*/_react.default.createElement(_DmsTextField.DmsTextField, {
    name: "bind_dn",
    label: _reactIntlUniversal.default.get("BindDN").d("Bind DN"),
    fullWidth: true,
    value: (_ldapSettingsData$bin = ldapSettingsData.bind_dn) !== null && _ldapSettingsData$bin !== void 0 ? _ldapSettingsData$bin : "",
    onChange: e => handleChange("bind_dn", e.target.value)
  })), /*#__PURE__*/_react.default.createElement(_material.Grid, {
    item: true,
    xs: 12,
    sm: 4,
    md: 4,
    lg: 4
  }, /*#__PURE__*/_react.default.createElement(_DmsTextField.DmsTextField, {
    name: "bind_password",
    label: _reactIntlUniversal.default.get("BindPassword").d("Bind Password"),
    type: "password",
    fullWidth: true,
    value: (_ldapSettingsData$bin2 = ldapSettingsData.bind_password) !== null && _ldapSettingsData$bin2 !== void 0 ? _ldapSettingsData$bin2 : "",
    onChange: e => handleChange("bind_password", e.target.value)
  })), /*#__PURE__*/_react.default.createElement(_material.Grid, {
    item: true,
    xs: 12,
    sm: 4,
    md: 4,
    lg: 4
  }, /*#__PURE__*/_react.default.createElement(_DmsTextField.DmsTextField, {
    name: "search_base_dn",
    label: _reactIntlUniversal.default.get("SearchBaseDN").d("Search Base DN"),
    fullWidth: true,
    value: (_ldapSettingsData$sea = ldapSettingsData.search_base_dn) !== null && _ldapSettingsData$sea !== void 0 ? _ldapSettingsData$sea : "",
    onChange: e => handleChange("search_base_dn", e.target.value)
  })), /*#__PURE__*/_react.default.createElement(_material.Grid, {
    item: true,
    xs: 12,
    sm: 4,
    md: 4,
    lg: 4
  }, /*#__PURE__*/_react.default.createElement(_DmsTextField.DmsTextField, {
    name: "search_filter",
    label: _reactIntlUniversal.default.get("SearchFilter").d("Search Filter"),
    fullWidth: true,
    value: (_ldapSettingsData$sea2 = ldapSettingsData.search_filter) !== null && _ldapSettingsData$sea2 !== void 0 ? _ldapSettingsData$sea2 : "",
    onChange: e => handleChange("search_filter", e.target.value)
  })), /*#__PURE__*/_react.default.createElement(_material.Grid, {
    item: true,
    xs: 12,
    sm: 4,
    md: 4,
    lg: 4
  }, /*#__PURE__*/_react.default.createElement(_DmsTextField.DmsTextField, {
    name: "user_name_attribute",
    label: _reactIntlUniversal.default.get("UserNameAttribute").d("User Name Attribute"),
    fullWidth: true,
    value: (_ldapSettingsData$use = ldapSettingsData.user_name_attribute) !== null && _ldapSettingsData$use !== void 0 ? _ldapSettingsData$use : "",
    onChange: e => handleChange("user_name_attribute", e.target.value)
  })), /*#__PURE__*/_react.default.createElement(_material.Grid, {
    item: true,
    xs: 12,
    sm: 4,
    md: 4,
    lg: 4
  }, /*#__PURE__*/_react.default.createElement(_DmsTextField.DmsTextField, {
    name: "user_email_attribute",
    label: _reactIntlUniversal.default.get("UserEmailAttribute").d("User Email Attribute"),
    fullWidth: true,
    value: (_ldapSettingsData$use2 = ldapSettingsData.user_email_attribute) !== null && _ldapSettingsData$use2 !== void 0 ? _ldapSettingsData$use2 : "",
    onChange: e => handleChange("user_email_attribute", e.target.value)
  })), /*#__PURE__*/_react.default.createElement(_material.Grid, {
    item: true,
    xs: 12,
    sm: 4,
    md: 4,
    lg: 4
  }, /*#__PURE__*/_react.default.createElement(_DmsTextField.DmsTextField, {
    name: "user_member_attribute",
    label: _reactIntlUniversal.default.get("UserMemberAttribute").d("User Member Attribute"),
    fullWidth: true,
    value: (_ldapSettingsData$use3 = ldapSettingsData.user_member_attribute) !== null && _ldapSettingsData$use3 !== void 0 ? _ldapSettingsData$use3 : "",
    onChange: e => handleChange("user_member_attribute", e.target.value)
  })), /*#__PURE__*/_react.default.createElement(_material.Grid, {
    item: true,
    xs: 12,
    sm: 4,
    md: 4,
    lg: 4
  }, /*#__PURE__*/_react.default.createElement(_DmsTextField.DmsTextField, {
    name: "user_attribute_group_search",
    label: _reactIntlUniversal.default.get("UserAttributeGroupSearch").d("User Attribute for Group Search"),
    fullWidth: true,
    value: (_ldapSettingsData$use4 = ldapSettingsData.user_attribute_group_search) !== null && _ldapSettingsData$use4 !== void 0 ? _ldapSettingsData$use4 : "",
    onChange: e => handleChange("user_attribute_group_search", e.target.value)
  })), /*#__PURE__*/_react.default.createElement(_material.Grid, {
    item: true,
    xs: 12,
    sm: 4,
    md: 4,
    lg: 4
  }, /*#__PURE__*/_react.default.createElement(_DmsTextField.DmsTextField, {
    name: "group_search_base_dn",
    label: _reactIntlUniversal.default.get("GroupSearchBaseDN").d("Group Search Base DN"),
    fullWidth: true,
    value: (_ldapSettingsData$gro = ldapSettingsData.group_search_base_dn) !== null && _ldapSettingsData$gro !== void 0 ? _ldapSettingsData$gro : "",
    onChange: e => handleChange("group_search_base_dn", e.target.value)
  })), /*#__PURE__*/_react.default.createElement(_material.Grid, {
    item: true,
    xs: 12,
    sm: 4,
    md: 4,
    lg: 4
  }, /*#__PURE__*/_react.default.createElement(_DmsTextField.DmsTextField, {
    name: "group_search_filter",
    label: _reactIntlUniversal.default.get("GroupSearchFilter").d("Group Search Filter"),
    fullWidth: true,
    value: (_ldapSettingsData$gro2 = ldapSettingsData.group_search_filter) !== null && _ldapSettingsData$gro2 !== void 0 ? _ldapSettingsData$gro2 : "",
    onChange: e => handleChange("group_search_filter", e.target.value)
  })), /*#__PURE__*/_react.default.createElement(_material.Grid, {
    item: true,
    xs: 12,
    sm: 4,
    md: 4,
    lg: 4
  }, /*#__PURE__*/_react.default.createElement(_DmsSwitch.DmsSwitch, {
    name: "use_ssl",
    label: _reactIntlUniversal.default.get("UseSSL").d("Use SSL?"),
    checked: ldapSettingsData.use_ssl || false,
    onChange: value => handleChange("use_ssl", value)
  })), /*#__PURE__*/_react.default.createElement(_material.Grid, {
    item: true,
    xs: 12,
    sm: 4,
    md: 4,
    lg: 4
  }, /*#__PURE__*/_react.default.createElement(_DmsSwitch.DmsSwitch, {
    name: "block_users_without_groups",
    label: _reactIntlUniversal.default.get("BlockUsersWithoutGroups").d("Block Users without Groups?"),
    checked: ldapSettingsData.block_users_without_groups || false,
    onChange: value => handleChange("block_users_without_groups", value)
  })))));
};
exports.DmsLdapAuthenticatorSettings = DmsLdapAuthenticatorSettings;